import { useState, useContext } from "react";
import { useNavigate } from "react-router-dom";
import { Button } from "@mui/material";
import { styled } from '@mui/material/styles';
import { userOnboardingContext } from "../../states/context/userOnboardingContext";
import rightArrow from "../../assets/images/new-arrow-left.svg"

const MainContainer = styled('div')(({ theme }) => ({
  display: "flex",
  fontFamily: "Figtree",
  height: "100%",
}));

const DetailsContainer = styled('div')(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  width: "100%",
  paddingTop: "80px",
  paddingLeft: "108px",
  paddingRight: "63px",
  background: "#f7f7f7",
}));

const FieldContainer = styled('div')(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  gap: "8px",
  "& label": {
    fontSize: "20px",
    fontWeight: "600",
    color: "#171717",
    fontFamily: "Figtree",
  },
  "& input": {
    borderRadius: "8px",
    border: "1px solid #E8E8E8",
    padding: "18px 20px 19px 20px",
    fontSize: "16px",
    fontWeight: "400",
    color: "#171717",
    background: "#F7F7F7",
    outline: "none",
    fontFamily: "Figtree",
  },
  "& span": {
    color: "red",
    fontSize: "14px",
  },
}));

const ImageContainer = styled('div')(({ theme }) => ({
  width: "566px",
  alignItems: "center",
  justifyContent: "center",
  display: "flex",
  background: "#E8E8E8",
}));

const ButtonContainer = styled('div')(({ theme }) => ({
  display: "flex",
  justifyContent: "end",
}));

const NextButton = styled(Button)(({ theme }) => ({
  width: "120px",
  height: "48px",
  borderRadius: "8px",
  backgroundColor: "#6933FF",
  border: "none",
  outline: "none",
  color: "white",
  fontSize: "16px",
  fontWeight: "600",
  textTransform: "capitalize",
  "& span": {
    fontFamily: "Figtree",
  },
  "&:hover": {
    backgroundColor: "#5a2fdd",
  },
  "&:disabled": {
    backgroundColor: "#E8E8E8",
    color: "#FFFFFF",
  },
}));

const WelcomeHeading = styled('h2')(({ theme }) => ({
  fontSize: "32px",
  fontWeight: "600",
  fontFamily: "Figtree",
  marginTop: 0,
  marginBottom: "24px",
  color: '#171717',
}));

const HeadPara = styled('p')(({ theme }) => ({
  fontSize: "16px",
  fontWeight: "400",
  color: "#747474",
  margin: 0,
  marginBottom: '40px',
}));

const FormContainer = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: '40px',
  color: '#171717',
}));

const UserBasicDetails = () => {
  const { user, setUser } = useContext(userOnboardingContext);
  const [errors, setErrors] = useState({
    email: "",
  });
  const navigate = useNavigate(); // Initialize useNavigate hook

  const validateEmail = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };

  const handleNext = (e) => {
    e.stopPropagation();
    if (!validateEmail(user.email)) {
      setErrors({ email: "Please enter a valid email address." });
    } else {
      setErrors({ email: "" });
      // Handle form submission or navigation
      updateUserApiCall();
    }
  };

  const updateUserApiCall = async () => {
    // Make API call to update user details

    try {
      const payload = {
        api: "",
        data: {
          name: user.name,
          email: user.email,
        },
      };
      // const result = await userOnboardingPublicApi(payload)
      // if(result.meta === "Success"){
      console.log("success");
      navigate("/onboarding/role");
      // }else{
      //   console.log("error")
      // }
    } catch (error) {
      console.log(error);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setUser({ ...user, [name]: value });
    if (name === "email" && value) {
      if (!validateEmail(value)) {
        setErrors({ ...errors, email: "Please enter a valid email address." });
      } else {
        setErrors({ ...errors, email: "" });
      }
    }
  };

  return (
    <MainContainer>
      <DetailsContainer>
        <div>
          <WelcomeHeading>Welcome to Kavida.ai</WelcomeHeading>
          <HeadPara>
            Help us <b>build your personalize AI agent</b> by telling us a
            little bit about yourself, the challenges you are facing, and your
            goals.
          </HeadPara>
        </div>
        <FormContainer>
          <FieldContainer>
            <label htmlFor="name">Full name</label>
            <input
              id="name"
              placeholder="Your full name"
              type="text"
              name="name"
              value={user.name}
              onChange={handleChange}
            />
          </FieldContainer>
          <FieldContainer>
            <label htmlFor="email">Email address</label>
            <input
              id="email"
              placeholder="example@email.com"
              type="email"
              name="email"
              value={user.email}
              onChange={handleChange}
            />
          </FieldContainer>
          <ButtonContainer>
            <NextButton
              onClick={handleNext}
              disabled={!user.name || !user.email || errors.email}
            >
              Next
              <img src={rightArrow} alt="rightArrow" style={{ marginLeft: '4px' }} />
            </NextButton>
          </ButtonContainer>
        </FormContainer>
      </DetailsContainer>
    </MainContainer>
  );
};

export default UserBasicDetails;
